import { observer } from "mobx-react-lite";
import { useContext } from "react";

import { CommandBarButton } from "@bps/fluent-ui";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { routes } from "@libs/routing/routes.ts";
import { BookingCalendarEventContext } from "@modules/booking/screens/booking-calendar/components/booking-calendar-event/BookingCalendarEventContext.tsx";
import { PatientCardIds } from "@modules/practice/screens/shared-components/types/patient-card-ids.enum.ts";
import { useStores } from "@stores/hooks/useStores.ts";

import { PersonaRowFormMenuButton } from "./PersonaRowFormMenuButton.tsx";

export const PersonaRowCommandButtons: React.FC = observer(() => {
  const { core, booking, routing } = useStores();

  const { calendarEvent, onShowEdit } = useContext(BookingCalendarEventContext);

  const { contact } = calendarEvent;

  const setShowApptInfoModal = () => {
    if (contact) {
      booking.ui.setAppointmentInformationModalSettings({
        contactId: contact.id
      });
    }
  };

  /* Demographic Items */
  const getDemographicsContextualMenuItems = () => {
    const contactId = contact && contact?.id;

    const demographicsMenuItems = [
      {
        key: "editDemographics",
        text: "Edit demographics",
        onClick: () => {
          onShowEdit(PatientCardIds.patientHeader)();
        },
        disabled: !core.hasPermissions(Permission.PatientWrite)
      },
      {
        key: "viewDemographics",
        text: "View demographics",
        onClick: () => {
          contactId &&
            routing.push(routes.contacts.contact.path({ id: contactId }));
        },
        disabled: !core.hasPermissions(Permission.PatientRead)
      }
    ];

    return demographicsMenuItems;
  };

  return (
    <>
      <CommandBarButton
        iconProps={{ iconName: "Contact" }}
        menuProps={{
          items: getDemographicsContextualMenuItems()
        }}
      />
      <CommandBarButton
        iconProps={{ iconName: "SearchCalendar" }}
        onClick={setShowApptInfoModal}
      />
      <PersonaRowFormMenuButton />
    </>
  );
});
